var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockSsl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5h-1V3c0-1.657-2-3-4-3S2 1.343 2 3v2H1a1 1 0 00-1 1v7a1 1 0 001 1h10a1 1 0 001-1V6a1 1 0 00-1-1zM8.795 6.5l.705.705L5 11.71l-2.5-2.5.705-.706L5 10.3l3.795-3.8zM6 1c1.5 0 3 .895 3 2v2H3V3c0-1.105 1.5-2 3-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSsl);
export default __webpack_public_path__ + "static/media/lock-ssl.86d9c7801fffb78ef6fae45f49be2ae8.svg";
export { ForwardRef as ReactComponent };